const items = [
  { img: 'https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?w=600&q=80', icon: 'ri-football-line', gradient: 'from-emerald-500 to-teal-600', title: '⚽ Sports Live', desc: 'All football, tennis, boxing, F1 matches — live sports from around the world in HD/4K.', span: 'sm:col-span-2 lg:col-span-1' },
  { img: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=600&q=80', icon: 'ri-movie-2-line', gradient: 'from-purple-500 to-pink-600', title: '🎬 Films & Cinema', desc: 'Thousands of films in 4K — blockbusters, classics, and new releases every week.', span: '' },
  { img: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=600&q=80', icon: 'ri-tv-line', gradient: 'from-purple-500 to-fuchsia-600', title: '📺 Series & VOD', desc: 'Thousands of series and films on demand — drama, action, comedy, documentaries and more.', span: '' },
  { img: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80', icon: 'ri-global-line', gradient: 'from-cyan-500 to-blue-600', title: '🌍 International Channels', desc: 'Over 150 countries covered — Arabic, European, African, American channels.', span: '' },
  { img: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=600&q=80', icon: 'ri-bear-smile-line', gradient: 'from-amber-400 to-orange-500', title: '👶 Kids Content', desc: 'Hundreds of channels and cartoons for your children — completely safe.', span: '' },
];

const Catalogue = () => (
  <section className="py-12 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
      <div className="text-center mb-10 sm:mb-14">
        <div className="inline-flex items-center gap-2 bg-[#862ce0]/10 border border-[#862ce0]/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
          <span className="text-sm font-medium text-[#b47ef3]">Catalogue</span>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 text-white">
          Sports, Films, Series{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#862ce0] to-[#c026d3]">&amp; much more</span>
        </h2>
        <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
          A complete catalogue for the whole family — from live sport to unlimited entertainment.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 max-w-6xl mx-auto">
        {items.map((item) => (
          <div key={item.title} className={`group relative rounded-2xl overflow-hidden aspect-[4/3] ${item.span}`}>
            <img alt={item.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" src={item.img} />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-6">
              <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center mb-3`}>
                <i className={`${item.icon} text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-1">{item.title}</h3>
              <p className="text-sm text-gray-300 leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Catalogue;
